import { FC, ReactElement } from 'react';

import { Page } from '../../../components';
import { ConnectedBlockRenderer, ConnectedPageHelmet } from '../../../connectors';
import { AppRoute } from '../../../entities/Routing/Routing';

import './CustomerServiceDeliveryPage.scss';

export const CustomerServiceDeliveryPage: FC = (): ReactElement => (
    <Page className="customer-service-delivery-page">
        <ConnectedPageHelmet appRoute={AppRoute.customerServiceDelivery} />
        <ConnectedBlockRenderer appRoute={AppRoute.customerServiceDelivery} />
    </Page>
);
